export default __webpack_public_path__ + "static/media/Gta5.064ffcb4.mp4";